import { takeLatest } from 'redux-saga/effects';
import * as actionTypesNV06 from '../actions/actionTypesNV06';
import { fetchAlfaOversiktSaga } from './NV06.saga';

export function* watchNV06Saga() {
  yield takeLatest(actionTypesNV06.NV06_ALFA_OVERSIKT_GET, fetchAlfaOversiktSaga);
}
